export default "__VITE_ASSET__4085628a__"